export const SHOW_TOAST = (state, payload) => {
  state.toast = payload;
};
export const SHOW_MODAL = (state, payload) => {
  state.modal = payload;
};
